/**
 * 策略模式  减少if-else
 */
export default class Context {
    //   private values: number;
    //   constructor(values: number) {
    //     this.values = values;
    //   }
    // 大域订单
    transferModeFun(transferMode, produceStatus) {
        switch (transferMode) {
            case 2:
                return this.produceStatusFun(produceStatus);
            case 3:
                return this.produceStatusFun(produceStatus);
        }
    }
    produceStatusFun(temp) {
        switch (temp) {
            case 0:
                return 0;
            case 60:
                return 1;
            case 70:
                return 2;
            case 80:
                return 3;
        }
    }
    // 自有平台订单
    personalFun(temp) {
        switch (temp) {
            case 0:
                return 0;
            case 70:
                return 1;
            case 80:
                return 2;
        }
    }
}
